<mat-form-field class="full-width">
  <mat-label>{{ label() }}{{ required() ? '*' : '' }}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="controller()"
    [matAutocomplete]="auto"
    (input)="filter($event.target.value)"
    (focus)="filter($event.target.value)"
    (blur)="empty($event.target.value)"
    [required]="required()"
  />
  <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayFn">
    @for (option of filteredOptions; track option) {
      <mat-option [value]="option">
        {{ option.fullName }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (controller().invalid && (controller().dirty || controller().touched)) {
    <mat-error>
      @if (controller().errors?.required) {
        {{ 'SHARED.VALIDATION.REQUIRED' | translate }}
      }
    </mat-error>
  }
</mat-form-field>
